import { z } from 'zod';
import { CuidSchema } from './crm.schemas.js';
import { PRIORITIES } from './crm.js';
import { BOARD_STAGES } from './board.js';

/**
 * مخططات لوح المهام.
 */

/**
 * تصفية اللوح.
 *
 * بلا ترقيم صفحات: اللوح يُقرأ كله دفعةً — أعمدةٌ متجاورة تُقارَن بالنظر —
 * وصفحةٌ ثانية من عمود تكسر القراءة. والحدّ في `BOARD_COLUMN_LIMIT` مع
 * ذكر الباقي برقمه.
 */
export const BoardQuerySchema = z.object({
  q: z.string().trim().max(200).optional(),
  assigneeId: CuidSchema.optional(),
  priority: z.enum(PRIORITIES).optional(),
  leadId: CuidSchema.optional(),
  accountId: CuidSchema.optional(),
  /** ما فات موعده وما زال غير منجز. */
  overdueOnly: z.coerce.boolean().optional(),
});
export type BoardQuery = z.infer<typeof BoardQuerySchema>;

/**
 * نقل بطاقة.
 *
 * المرحلة وحدها: البطاقة تُسحب ولا تُحرَّر أثناء السحب. وتغييرُ المسؤول
 * أو الموعد له مساره — خلطُهما هنا يجعل سحبةً واحدة تكتب ثلاثة حقول.
 */
export const MoveCardSchema = z.object({
  stage: z.enum(BOARD_STAGES),
});
export type MoveCardInput = z.infer<typeof MoveCardSchema>;
